import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

function Menu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="menu">
      <div className="menu-toggle" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>
      <ul className={isOpen ? 'menu-list open' : 'menu-list'}>
        <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
        <li><a href="/#about" onClick={() => setIsOpen(false)}>About</a></li>
        <li><Link to="/donations" onClick={() => setIsOpen(false)}>Donations</Link></li>
        <li><Link to="/gift-cards" onClick={() => setIsOpen(false)}>Gift Cards</Link></li>
        <li><a href="/#contact" onClick={() => setIsOpen(false)}>Contact</a></li>
        <li><a href="/#donate" onClick={() => setIsOpen(false)}>Donate</a></li>
      </ul>
    </nav>
  );
}

export default Menu;